import { render } from "./NavbarMovil.vue?vue&type=template&id=074e9a38"
import script from "./NavbarMovil.vue?vue&type=script&lang=js"
export * from "./NavbarMovil.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__